import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Botón "Volver al Onboarding" que regresa al panel central ESE.
 * Aparece solo cuando el usuario es del perfil ESE.
 */
export default function VolverOnboardingBtn({ user }) {
  const navigate = useNavigate();
  if (user?.rol !== 'ese') return null;
  return (
    <button
      type="button"
      onClick={() => navigate('/ese/panel')}
      data-testid="volver-onboarding-btn"
      className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-800 hover:bg-emerald-100 transition-colors"
    >
      <ArrowLeft className="w-3.5 h-3.5" />
      Volver al Onboarding
    </button>
  );
}
